<div class="radio-group">
    @for (option of options(); track $index) {
    <button class="radio-item" [class.disabled]="disabled()"
        (click)="selectOption(option.value)">
        <div class="radio-button"  [class.selected]="value === option.value">
            <div class="radio-inner"></div>
        </div>
        <span class="radio-label" [class.selected]="value === option.value">{{ option.label }}</span>
    </button>
    }

</div>